module.exports = __webpack_public_path__ + "img/active-2.bf41c366.png";